// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2c1900eb","239":"6e8c6297","371":"4d3b5a80","455":"1065a3ac"}[chunkId] + ".chunk.js";
};